<template>
  <div class="c-sidebar">
    <div
      class="sidebar"
      :class="classes"
      @keyup.esc="toggle"
    >
      <aside class="content">
        <slot name="content" />

        <h5 class="mobile-copy">
          Desenvolvido por
          <a
            class="kaledo"
            target="_blank"
            href="https://www.kaledo.com.br/"
          >Kaledo</a>
          &copy; {{ year }}
        </h5>
      </aside>
      <div
        class="backdrop"
        @click="toggle"
      />

      <h5 class="copy">
        Desenvolvido por
        <a
          class="kaledo"
          target="_blank"
          href="https://www.kaledo.com.br/"
        >Kaledo</a>
        &copy; {{ year }}
      </h5>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: Boolean
  },
  computed: {
    classes () {
      return this.isOpen && '-visible'
    },
    year () {
      const now = new Date()
      return now.getFullYear()
    }
  },
  watch: {
    isOpen (value) {
      this.$el.parentElement.style.overflow = value ? 'hidden' : 'auto'
    }
  },
  methods: {
    toggle () {
      this.$el[this.isOpen ? 'blur' : 'focus']()
      this.$emit(this.isOpen ? 'close' : 'open')
    }
  }
}
</script>

<style lang="scss">
@import '~@styles/convenia-components/reference.scss';

$c-sidebar-top-position: 66px;
$c-sidebar-max-width: 280px;
$c-sidebar-desktop-max-width: 240px;
$c-sidebar-max-height: calc(100vh - 66px);
$c-sidebar-desktop-width: 28%; // ~200px @ 768vw

.c-sidebar {
  @include medium-up {
    width: 28%;
    max-width: $c-sidebar-desktop-max-width;
    max-height: $c-sidebar-max-height;
    position: relative;
  }

  .sidebar {
    & > .copy { display: none; }

    @include medium-up {
      width: 28%;
      max-width: $c-sidebar-desktop-max-width;
      height: $c-sidebar-max-height;
      top: $c-sidebar-top-position;
      position: fixed;

      & > .copy {
        display: block;
        color: #8c92b1;
        position: absolute;
        bottom: 0;
        width: 100%;
        text-align: center;
        font-weight: 400;
        padding: $spacing 0;

        & > .convenia {
          text-decoration: none;
          text-transform: uppercase;
          font-size: 11px;
          color: #8fb2f4;
        }
      }
    }

    & > .content {
      width: 100%;
      max-width: $c-sidebar-max-width;
      position: fixed;
      background: #fff;
      top: $c-sidebar-top-position;
      left: 0;
      bottom: 0;
      z-index: 100;
      pointer-events: none;
      overflow: auto;
      transform: translate3D(-100%, 0, 0);
      -webkit-overflow-scrolling: touch;
      transition: all .4s cubic-bezier(.25, .8, .25, 1);
      transition-property: transform;
      will-change: transform;

      & > .mobile-copy {
        color: #8c92b1;
        width: 100%;
        text-align: center;
        font-weight: 400;
        padding: $spacing 0;

        & > .kaledo {
          text-decoration: none;
          text-transform: uppercase;
          font-size: 11px;
          color: #8fb2f4;
        }
      }

      @include medium-up {
        position: static;
        transform: translate3D(0, 0, 0);
        pointer-events: all;
        z-index: 1;
        transition: none;
        bottom: auto;
        background: transparent;
        padding-top: 20px;

        & > .mobile-copy { display: none; }
      }
    }

    & > .backdrop {
      position: fixed;
      top: $c-sidebar-top-position;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 99;
      pointer-events: none;
      background-color: rgba(#000, .54);
      opacity: 0;
      transition: all .5s cubic-bezier(.35, 0, .25, 1);
      transition-property: opacity;
      will-change: opacity;

      @include medium-up {
        display: none;
        transition: none;
      }
    }
    @include medium-down {
      &.-visible > .content {
        @include elevation(3);
        pointer-events: auto;
        transform: translate3D(0, 0, 0);
      }

      &.-visible > .backdrop {
        opacity: 1;
        pointer-events: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/convenia-components/CSidebar.vue